import React from "react";

interface UserCommonProps {
  name: string;
  email: string;
  imageUrl?: string;
  userType: number;
}

const UserCommon: React.FC<UserCommonProps> = ({
  name,
  email,
  imageUrl,
  userType,
}) => {
  const getUserTypeLabel = (type: number): string => {
    switch (type) {
      case 1:
        return "Owner";
      case 2:
        return "Agent";
      case 3:
        return "Buyer";
      default:
        return "User";
    }
  };

  return (
    <div className="profile px-4 mb-4 box-house">
      <div className="row">
        <div className="col-sm-12 ps-md-0 d-block d-lg-flex justify-content-lg-between px-5">
          <h6 className="plot-location-text me-5">
            <i className="bi bi-person me-2"></i>
            {name}
          </h6>
          <p className="ms-1 me-5">
            <i className="bi bi-envelope-at me-2"></i>
            {email}
          </p>
          <p className="ms-1">
            <i className="bi bi-person-badge me-2"></i>
            {getUserTypeLabel(userType)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserCommon;
